export default "__VITE_ASSET__ApU9wgP9__"